import { i18nConfig } from '../constants';

/**
 * Check if the locale is acceptable and allowed in the app
 */
export const getIsLocaleAcceptable = (locale: string, acceptableLocalesList = i18nConfig.locales) => {
  return !!acceptableLocalesList.find((acceptableLocale) => acceptableLocale === locale);
};
